import { useEffect } from 'react'
import { useSetRecoilState } from 'recoil'
import eventBus from '@/services/eventBus'
import recoilStateUpdaters from '@/recoil/recoil.stateUpdaters.ts'
import usersAtom from '@/pages/Users/users.atom.ts'

const useUsersEventsSubscriptions = () => {
  const setState = useSetRecoilState(usersAtom)

  useEffect(() => {
    const createSub = eventBus.sub('users.created', (item) => {
      recoilStateUpdaters.itemCreated(setState, item)
    })

    const updateSub = eventBus.sub('users.updated', (item) => {
      recoilStateUpdaters.itemUpdated(setState, item)
    })

    const removeSub = eventBus.sub('users.deleted', (id) => {
      recoilStateUpdaters.itemDeleted(setState, id)
    })

    return () => {
      createSub()
      updateSub()
      removeSub()
    }
  }, [])
}

export default useUsersEventsSubscriptions
